import { apiV1Endpoint } from "../api/v1";

export const SITEKEY = "6LfyGo8bAAAAAPNwvOlUiLfMelq9dII867qVxKvs";
export const EQARI_GOOGLE_KEY = "AIzaSyAtdkaVektzwf-CUDmq2J6lGFMDfO7uxio";
export const EQARI_GOOGLE_KEY_TRANSLATION = "AIzaSyB2SrxenJdlrPFPg_IHF_eZ7_thC0DP4Qg";

export const TRANSLATION_URL = "https://translation.googleapis.com/language/translate/v2";

export const BASE_URL = "https://connect.eqarcom.ae/api/v1";
export const serverUrl = "https://app.eqarcom.ae";

export const propertyService = apiV1Endpoint;
export const leaseService = apiV1Endpoint;
export const unitService = apiV1Endpoint;
export const authService = apiV1Endpoint;
export const contactUs = apiV1Endpoint;
export const managementService = apiV1Endpoint;
export const maintenanceService = apiV1Endpoint;
export const mediaService = apiV1Endpoint;
export const contractService = apiV1Endpoint;
export const maintenanceTicketsService = apiV1Endpoint + "/property-landlord/asset/tickets";
export const singleMaintenanceTicketsService = apiV1Endpoint + "/property-landlord/asset/ticket";
export const scheduleVisitService = apiV1Endpoint + "/property-landlord";
export const baseContractService = apiV1Endpoint + "/lead-to-lease/contract";
export const bookingFormUnit = apiV1Endpoint + "/property-landlord";
export const dashboard = apiV1Endpoint + "/power-bi/report";
export const getUserService = apiV1Endpoint + "/masterUser";
export const paymentProcessService = apiV1Endpoint + "/booking/getPaymentLink";
export const getpaymentLinkService = apiV1Endpoint + "/booking/getPaymentLinkNow";
export const updateApprovedRentService = apiV1Endpoint + "/unit/uploadApprovedAnnualUnitRent";
export const printStatementServices = apiV1Endpoint + "/leasing/downloadLeaseStatement/";
export const gridSettings = apiV1Endpoint + "/user/getGridSettings?screen=";
export const saveGidSettings = apiV1Endpoint + "/user/saveGridSettings";
export const addNewSingleProperty = apiV1Endpoint + "/property";
export const addNewSingleUnit = apiV1Endpoint + "/unit/createSingleUnit";
